import { Modal, Box } from "@mui/material";
import { IoMdClose } from "react-icons/io";
import CustomPagination from "../../../../../../components/table/CustomPagination";
import { ModalStyle } from "../../../../../../helpers/appHelpers";
import { DetailedExchangeRateHistoryDto } from "../../../../../../models/exchange-rate-history.dto";
import { useGetExchangeRateHistory } from "../../../../../../services/exchange-rate-history.service";
import { CurrencyDto } from "../../../../../../models/currency.dto";
import { ExchangeRateHistoryColumns } from "../data";
import CustomStyledTable from "../../../../../../components/table/CustomStyledTable";
import { useManageTableWithStateVariables } from "../../../../../../helpers/useManageTable";

type ExchangeRateHistoryModalProps = {
	fromCurrency: CurrencyDto;
	toCurrency: CurrencyDto;
	openModal: boolean;
	setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const ExchangeRateHistoryModal = ({
	fromCurrency,
	toCurrency,
	openModal,
	setOpenModal,
}: ExchangeRateHistoryModalProps) => {
	const {
		tableAPIRef,
		tableData,
		isLoading,
		page,
		pageCount,
		handlePageChange,
	} = useManageTableWithStateVariables<DetailedExchangeRateHistoryDto>({ 
		fetchHook: useGetExchangeRateHistory,
		options: { 
			fromCurrencyId: fromCurrency.id,
			toCurrencyId: toCurrency.id,
		}
	});

	return (
		<Modal
			open={openModal}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
		>
			<Box sx={ModalStyle} width={1260} fontSize={"13px"}>
				<div className="flex justify-between items-center pt-4 pb-6">
					<div className="flex items-center gap-5">
						<h1 className="font-bold text-lg">Exchange Rate History</h1>
						<div className="bg-[#6978F0] font-semibold text-white whitespace-nowrap 
							text-xs px-2 py-[6px] rounded flex items-center justify-center"
						>
							<p>
                                {fromCurrency?.name + ` (${fromCurrency?.code})` + " - " 
                                    + toCurrency?.name + ` (${toCurrency?.code})`}
                            </p>
						</div>
					</div>
					<button
						onClick={() => setOpenModal(false)}
					>
						<IoMdClose className="text-xl hover:scale-[1.1]" />
					</button>
				</div>
				<hr className="mb-6" />
				<CustomStyledTable
					rows={tableData}
					columns={ExchangeRateHistoryColumns}
					apiRef={tableAPIRef}
					loading={isLoading}
					pageCount={pageCount}
					pagination={
						<CustomPagination 
							pageCount={pageCount} 
							pageState={page}
							handleChange={handlePageChange}
						/>
					}
				/>
			</Box>
		</Modal>
	);
};

export default ExchangeRateHistoryModal;